import { AudioGate } from './AudioGate';

function beep(freq: number, durationMs: number, volume = 0.05) {
  if (AudioGate.isMuted()) return;
  const ctx = new AudioContext();
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = 'square';
  osc.frequency.value = freq;
  gain.gain.value = volume;
  osc.connect(gain);
  gain.connect(ctx.destination);
  osc.start();
  setTimeout(() => {
    osc.stop();
    void ctx.close();
  }, durationMs);
}

export const SynthSfx = {
  jump: () => beep(520, 80, 0.04),
  step: () => beep(180, 40, 0.02),
  motor: () => beep(110, 220, 0.03),
  win: () => beep(880, 160, 0.05),
};
